import Header from "../../Sections/Header/Header"
import Sidebar from "../../Sections/Sidebar/Sidebar"

export default function MainSections({children}) {
    return (
        <div className="flex md:grid md:grid-cols-mainGrid">
            <div className="min-h-full relative shadow-md" >
                <Sidebar />
            </div>

            <div className="flex-1">
                <Header />
                {children}
            </div>
        </div>
    )
}
